import medianOf from "../utilities/median-of";

export default {
    label: "Mediana",
    callback: medianOf,
    format: true
}


// WEBPACK FOOTER //
// ./src/aggregators/median.js